/* eslint-disable camelcase */
import { formatDayLabel } from '../../../utils/formatDate';

import OverviewActivityCard from './OverviewActivityCard';
import OverviewStatusPills from './OverviewStatusPills';

function OverviewDaySection({
    dato,
    aktiviteterForDato = [],
    lunsj = null,
    middag = null,
    aktivitetPameldApent = 'J'
}) {
    const pameldteAktiviteter = aktiviteterForDato
        .filter(a => a.pameldt === 'J')
        .sort((a, b) => (a.fratid ?? '').localeCompare(b.fratid ?? ''));

    return (
        <section className="overview-day">
            <div className="overview-day__header">
                <div className="overview-day__heading">
                    <h3 className="overview-day__title">{formatDayLabel(dato)}</h3>
                    <p className="overview-day__sub">
                        {pameldteAktiviteter.length > 0
                            ? `${pameldteAktiviteter.length} aktivitet${pameldteAktiviteter.length > 1 ? 'er' : ''}`
                            : 'Ingen aktiviteter'}
                    </p>
                </div>
            </div>

            <OverviewStatusPills
                aktiviteter={aktiviteterForDato}
                lunsj={lunsj}
                middag={middag}
                aktivitetPameldApent={aktivitetPameldApent}
            />

            {pameldteAktiviteter.length > 0 && (
                <div className="overview-day__section">
                    <div className="overview-day__section-header">
                        <h4 className="overview-day__section-title">Aktiviteter</h4>
                    </div>

                    <div className="overview-activity-grid">
                        {pameldteAktiviteter.map(aktivitet => (
                            <OverviewActivityCard key={aktivitet.akt_id} aktivitet={aktivitet} />
                        ))}
                    </div>
                </div>
            )}
        </section>
    );
}

export default OverviewDaySection;
